import { useState } from 'react';
import Input from 'src/components/base/Input/Input';
import './PopAheadSearch.scss';

type Props = {
  id: string;
  placeholder?: string;
  onSearch: (keywords: string) => void;
};

export default function PopAheadSearch({ id, placeholder, onSearch }: Props) {
  const [isSearching, setIsSearching] = useState(false);
  const [searchKeywords, setSearchKeywords] = useState('');

  const handleSearch = (e: any) => {
    const newValue = e.target.value; // always trim

    /* the new value contains white space */
    if (newValue.length === 1 && newValue.trim() !== newValue) {
      return;
    }

    setSearchKeywords(newValue);
    onSearch(newValue);
  };

  const onFocusSearch = () => {
    const input = document.getElementById(id);

    if (input) input.focus();

    setIsSearching(true);
  };

  return (
    <div onClick={() => onFocusSearch()} className="pop-ahead-container">
      <Input
        onChange={(e: any) => {
          handleSearch(e);
        }}
        onFocus={() => setIsSearching(true)}
        onBlur={(e: any) => {
          setIsSearching(e.target.value.trim().length);
        }}
        value={searchKeywords || ''}
        className={`pop-ahead-container__search-input ${
          isSearching ? '-searching' : ''
        }`}
        isSearchInput={true}
        isForForm={false}
        placeholder={isSearching ? placeholder || 'Search' : ''}
        id={id}
      />
    </div>
  );
}
